(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const thumbsSwiper = new Swiper(section.querySelector(".productVisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 6,
    })

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: section.querySelector(".productVisualSwiperNext"),
            prevEl: section.querySelector(".productVisualSwiperPrev"),
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
        // pinch or double tap to zoom, swiper blocks the browser's own pinch zoom on the slider
        zoom: {
            maxRatio: 3,
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            },
            zoomChange: function (swiper, scale, imageElement) {
                // swap in the large image the first time it's zoomed
                if (scale <= 1 || !imageElement.dataset.zoomSrc) {
                    return;
                }

                imageElement.src = imageElement.dataset.zoomSrc;
                delete imageElement.dataset.zoomSrc;
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            // if there is a bundle product, reveal box contents
            if (this.classList.contains('productOptionsItemValues')) {
                if (section.querySelector('.productOptionsBundle')) {
                    section.querySelector('.productOptionsBundle')?.classList.add('active');
                    // if the information is variant level, show correct info
                    if (section.querySelector('.productOptionsBundleList.group')) {
                        section.querySelectorAll('.productOptionsBundleList').forEach(el => {
                            el.dataset.value === this.value ? el.classList.add('active') : el.classList.remove('active');
                        })
                    }
                }
            }
            updateProduct().catch(e => console.error(e));
        });
    })

    async function updateProduct() {
        // if no atc button - out of stock
        if (!section.querySelector(".productOptionsBottomATC")) return;
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionsItem`).forEach(group => {
                options.push(group.querySelector(`select`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productOptionsBottomATC").disabled = true;
            section.querySelector(".productOptionsBottomATC").textContent = "Not Available";
            return;
        }

        // update SKU if available
        if (activeVariant.sku && section.querySelector(".productSku")) {
            section.querySelectorAll(".productSku").forEach(el => el.textContent = activeVariant.sku);
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        // update price
        section.querySelectorAll('.productPriceCompare').forEach(element => {
            element.textContent = "";
        })
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelectorAll('.productPriceCompare').forEach(element => {
                element.textContent = price(activeVariant.compare_at_price);
            })
        }
        section.querySelectorAll('.productPriceActual').forEach(element => {
            element.textContent = price(activeVariant.price);
        })

        // savings
        let savings = activeVariant.compare_at_price - activeVariant.price;
        section.querySelectorAll('.productNotice').forEach(element => {
            element.textContent = ``;
        })
        if (savings > 0) {
            section.querySelectorAll('.productNotice').forEach(element => {
                element.textContent = `Save ${price(savings)}`;
            })
        }

        // if discount pill, show the price at checkout
        if (section.querySelector('.productDiscountTextAmount') && section.querySelector('.productDiscountTextAmount').dataset.percent) {
            const salePrice = activeVariant.price - (activeVariant.price * parseInt(section.querySelector('.productDiscountTextAmount').dataset.percent) / 100)
            section.querySelectorAll('.productDiscountTextAmount').forEach(el => el.textContent = price(salePrice));
        }

        // if bnpl, update the prices on variant change these elements offer four payments plan
        section.querySelectorAll('.productBNPLPayments')?.forEach(element => {
            element.classList.contains('productBNPLPaymentsMonthly')
                ? element.textContent = price(activeVariant.price / 6)
                : element.textContent = price(activeVariant.price / 4);
        })

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productOptionsBottomATC").disabled = false;
            section.querySelector(".productOptionsBottomATC").textContent = section.querySelector(".productOptionsBottomATC")?.dataset?.text || 'Add To Cart';
        } else {
            section.querySelector(".productOptionsBottomATC").disabled = true;
            section.querySelector(".productOptionsBottomATC").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /************
     Product Form
     ************/

    // if there is a form, set up dialog and add listener to close upon submit
    if (section.querySelector('.productOptionsForm')) {
        section.querySelector('.productOptionsForm').addEventListener('close', () => document.querySelector('body').classList.remove('noScroll'));
        section.querySelector('.productOptionsForm').addEventListener('click', function (e) {
            if (e.target === this) this.close();
        });
        section.querySelector('.productOptionsFormExit').addEventListener('click', () => section.querySelector('.productOptionsForm').close());

        // when form loads, add listeners and remove observer
        function waitForProductForm(section) {
            const observer = new MutationObserver((mutations, obs) => {
                const wrapper = section.querySelector('.productOptionsForm');
                const form = wrapper?.querySelector('form');
                if (form) {
                    obs.disconnect();
                    gatherCustomData(form);
                }
            });

            observer.observe(section, {
                childList: true,
                subtree: true
            });
        }

        // add listener for form submit
        function gatherCustomData(form) {
            form.addEventListener('submit', async function (e) {
                // close and remove form
                section.querySelector('.productOptionsForm').close();
                section.querySelector('.productOptionsForm').remove();
                // update the atc button text
                const submitText = section.querySelector('.productOptionsBottomATC')?.dataset.formComplete;
                if (submitText) {
                    section.querySelector('.productOptionsBottomATC').textContent = submitText;
                }
                // remove button listener
                section.querySelector('.productOptionsBottomATC').removeEventListener('click', openForm);
            })
        }

        // on load begin watching for form
        waitForProductForm(section);
    }

    function openForm() {
        document.querySelector('body').classList.add('noScroll');
        section.querySelector('.productOptionsForm').showModal();
    }


    // atc opens the form
    section.querySelector('.productOptionsBottomATC')?.addEventListener("click", openForm);

    /********
     Dialogs
     *********/

    // all close buttons
    section.querySelectorAll('.productDialogExit')?.forEach(exit => {
        exit.addEventListener('click', function () {
            this.closest('.productDialog').close();
        })
    })

    // all dialogs close events
    section.querySelectorAll('.productDialog')?.forEach(dialog => {
        // close event
        dialog.addEventListener('close', function () {
            dialog.classList.remove('active');
            document.querySelector('body').classList.remove('noScroll');
        })
        // click close
        dialog.addEventListener('click', function (e) {
            if (e.target === this) this.close();
        })
    })

    // dialogs
    const imageDialog = section.querySelector('.productImage');
    const slideInDialog = section.querySelector('.productSlide');

    // zoom button on the swiper
    section.querySelector('.productVisualSwiperZoom')?.addEventListener('click', function () {
        // find source of selected slide
        const src = productSwiper.slides[productSwiper.activeIndex].querySelector('img')?.src;
        // if a video or no source, do nothing
        if (src) {
            openImageDialog(src);
        }
    })

    // open mask info slide
    section.querySelectorAll('.productMaskSelectButton')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn("info");
        })
    })

    // additional information buttons
    section.querySelectorAll('.productAdditionalButton')?.forEach(button => {
        button.addEventListener('click', function () {
            // type will determine which additional information
            const type = this.dataset.type;
            if (type === 'faq') {
                if (document.querySelector('#faq')) {
                    document.querySelector('#faq').scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    })
                    // check if there is the features menu exists and account for it
                    if (document.querySelector('.pdpMenuSticky')) {
                        setTimeout(() => {
                            window.scrollBy({
                                behavior: "smooth",
                                top: -document.querySelector('.pdpMenuSticky').offsetHeight
                            });
                        }, 1000)
                    }
                }
                return;
            }
            // ensure there is information added to section
            let infoAvailable = false;
            // reveal pertinent information
            slideInDialog.querySelectorAll('.productSlideSectionContent')?.forEach(section => {
                if (section.dataset.type === type) {
                    section.classList.add('active');
                    infoAvailable = true;
                } else {
                    section.classList.remove('active');
                }
            })
            // if a match found, reveal dialog
            if (infoAvailable) {
                openSlideIn("additional");
            }
        })
    })

    // mask help section
    section.querySelectorAll('.productMaskHelp')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn("mask");
        })
    })

    // mask type section
    section.querySelectorAll('.productMaskTypeHelp')?.forEach(button => {
        button.addEventListener('click', function () {
            section.querySelectorAll('.productSlideType .productSlideSectionContent[data-type]').forEach(item => {
                item.dataset.type === this.dataset.type ? item.classList.add('active') : item.classList.remove('active');
            })
            openSlideIn("type");
        })
    })

    // mask size guide
    section.querySelectorAll('.productOptionsItemLabelGuide')?.forEach(button => {
        button.addEventListener('click', function () {
            if (this.classList.contains('maskPage')) {
                section.querySelectorAll('.productSlideSectionContent').forEach(item => {
                    item.dataset.id === activeVariant.id.toString() ? item.classList.add('active') : item.classList.remove('active');
                })
            }
            openSlideIn("size");
        })
    })

    // bnpl
    section.querySelectorAll('.productBNPL')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn("bnpl");
        })
    })

    // companion product info
    section.querySelectorAll('.productOptionsCompanionImageButton')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn(this.dataset.product);
        })
    })

    function openSlideIn(type) {
        // open relevant area
        slideInDialog.querySelectorAll('.productSlideSection')?.forEach(section => {
            if (section.dataset.type === type) {
                section.classList.add('active');
            } else {
                section.classList.remove('active');
            }
        })
        // open the dialog
        slideInDialog.showModal();
        document.querySelector('body').classList.add('noScroll');
        slideInDialog.classList.add('active');
    }

    function openImageDialog(src) {
        // add and show image on dialog
        section.querySelector('.productImageContainerItem').src = src;
        imageDialog.showModal();
        document.querySelector('body').classList.add('noScroll');
    }

    /**************
     Multi-product Swap
     ***************/

    // buttons reload the template with different products
    document.querySelectorAll(".productOptionsMultiItem")?.forEach(async el => {

        // add listener
        el.addEventListener('click', async function () {
            // if active, current product
            if (this.classList.contains("active")) {
                return;
            }

            // get the handle
            const targetHandle = this.dataset.handle;

            // if not marked as a section reload, reload whole page
            if (!this.closest('.productOptionsMulti').classList.contains('active')) {
                window.location.href = `/products/${targetHandle}`;
                return;
            }

            // save main element
            const main = document.querySelector(`#${sectionID}`);

            // fetch the other page
            await fetchSection(targetHandle, main);

            // re-run JS
            fetchOldScript(main);
        })
    })

    // select change reloads the template with different products
    document.querySelectorAll(".productOptionsMultiItemSelect")?.forEach(async (element) => {

        // add listener
        element.addEventListener("change", async function () {

            // return if value is empty
            if (this.value === "") return;
            // get the handle
            const targetHandle = this.value;

            // if not marked as a section reload, reload whole page
            if (!element.closest('.productOptionsMulti').classList.contains('active')) {
                window.location.href = `/products/${targetHandle}`;
                return;
            }

            // save main element
            const main = document.querySelector(`#${sectionID}`);

            // fetch the other page
            await fetchSection(targetHandle, main);
            // re-run JS
            fetchOldScript(main);
        });
    })

    async function fetchSection(handle, main) {
        const html = await fetch(`/products/${handle}?section_id=${sectionID}`)
            .then(response => response.text())

        // get JUST the <main> element
        const parser = new DOMParser();
        const targetDoc = parser.parseFromString(html, "text/html");
        const mainHTML = targetDoc.querySelector(`#${sectionID}`).innerHTML;

        // update html of main
        main.innerHTML = mainHTML;
    }

    function fetchOldScript(section) {
        Array.from(section.querySelectorAll("script"))
            .forEach(oldScriptEl => {
                const newScriptEl = document.createElement("script");

                Array.from(oldScriptEl.attributes).forEach(attr => {
                    newScriptEl.setAttribute(attr.name, attr.value)
                });

                const scriptText = document.createTextNode(oldScriptEl.innerHTML);
                newScriptEl.appendChild(scriptText);

                oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
            });
    }

    /********************
     Compatible Products
     ********************/
    if (section.querySelector('.productVisualCompatible')) {
        // compatible product swipers
        section.querySelectorAll('.productVisualCompatibleGroup').forEach(el => {
            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 14,
            });
        })

        // change on select variants
        section.querySelectorAll('.productVisualCompatibleGroupSlideSelect')?.forEach(el => {
            el.addEventListener('change', function () {
                this.closest('.productVisualCompatibleGroupSlide').querySelector('.productVisualCompatibleGroupSlideAtc').dataset.variant = this.value;
            })
        })

        // add to cart listener
        section.querySelectorAll('.productVisualCompatibleGroupSlideAtc')?.forEach(atc => {
            atc.addEventListener('click', async function () {

                // add loading animation
                this.classList.add("loading");

                let formData = {
                    items: [{
                        quantity: 1,
                        id: parseInt(this.dataset.variant),
                    }]
                };

                // add product
                await addProduct(formData);

                // remove loading animation
                this.classList.remove("loading");

                // open cart
                await openCart();
            })
        })
    }

    /*************
     Out of stock
     *************/
    // if out of stock, button is added and we use the klaviyo oos function
    if (section.querySelector('.productOptionsOOSInput')) {
        // input will enable button for submit
        section.querySelector('.productOptionsOOSInput').addEventListener('change', function () {
            this.value !== "" ?
                section.querySelector('.productOptionsOOSButton').disabled = false :
                section.querySelector('.productOptionsOOSButton').disabled = true;
        })

        section.querySelector('.productOptionsOOSButton').addEventListener('click', async function () {
            await sendKlaviyoBackInStockRequest(section.querySelector('.productOptionsOOSInput').value, activeVariant.id);
            section.querySelector('.productOptionsOOS').innerHTML = `
                <div class="productOptionsOOSTitle">Email submitted!</div>
                <div class="productOptionsOOSText">You will be notified when this item is back in stock.</div>
`;
        })
    }

}());